import { useRouter } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { getIsExistingSr } from 'common/utils/srUtils';
import { ReactComponent as PrevIcon } from 'images/icons/prev.svg';
import { ReactComponent as NextIcon } from 'images/icons/next.svg';
import Tooltip from 'common/components/tooltip';
import useTexts from '../useTexts';

function NextOrPrevSR({ srId }) {
  const queryClient = useQueryClient();
  const router = useRouter();
  const { nextTicketText, prevTicketText } = useTexts();
  const isExistingSR = getIsExistingSr(srId);
  const queryCache = queryClient.getQueryCache();

  let loadedSrIds;
  let index;
  let isNextDisable;
  let isPrevDisable;
  let dataUpdatedAt = 0;

  const queueDataCachedQueries = Object.entries(queryCache.queriesMap)
    .filter(([key]) => key.includes('"queueData"'))
    .map(([, query]) => query);

  queueDataCachedQueries?.forEach((query) => {
    const srIdsList = (query?.state?.data?.serviceRequests || []).map((item) => item[0].value) || [];
    const tempIndex = srIdsList.findIndex((item) => Number(item) === srId);
    if (tempIndex !== -1 && query.state.dataUpdatedAt > dataUpdatedAt) {
      index = tempIndex;
      dataUpdatedAt = query.state.dataUpdatedAt;
      loadedSrIds = srIdsList;
      isNextDisable = index === loadedSrIds.length - 1;
      isPrevDisable = index === 0;
    }
  });

  const handleClickPrev = () => router.navigate({ to: `?id=${loadedSrIds[index - 1]}` });

  const handleClickNext = () => router.navigate({ to: `?id=${loadedSrIds[index + 1]}` });

  return (
    <>
      {Boolean(loadedSrIds?.length) && isExistingSR && index !== -1 && (
        <div className="next-or-prev-sr">
          <Tooltip
            text={
              <button onClick={handleClickPrev}
                      disabled={isPrevDisable}
                      data-testid="prev-sr"
              >
                <PrevIcon />
              </button>
            }
            title={prevTicketText}
            placement="top"
            disableInteractive={isPrevDisable}
            disableHoverListener={isPrevDisable}
            disableTouchListener={isPrevDisable}
          />
          <Tooltip
            text={
              <button onClick={handleClickNext}
                      disabled={isNextDisable}
                      data-testid="next-sr"
              >
                <NextIcon />
              </button>
            }
            title={nextTicketText}
            placement="top"
            disableInteractive={isNextDisable}
            disableHoverListener={isNextDisable}
            disableTouchListener={isNextDisable}
          />
        </div>
      )}
    </>
  );
}

export default NextOrPrevSR;
